import Reconciler from 'react-reconciler'

import pkg from '../../package.json'

import hostconfig from './hostconfig'

export { default as createPortal } from './createPortal'

export const PixiFiber = Reconciler(hostconfig)

/**
 * Inject into React Devtools
 */
export function injectDevtools() {
  PixiFiber.injectIntoDevTools({
    bundleType: process.env.NODE_ENV !== 'production' ? 1 : 0,
    version: pkg.version,
    rendererPackageName: pkg.name,
    findHostInstanceByFiber: PixiFiber.findHostInstance,
  })
}
